(()=>{'use strict';
function initHero(root){
 if(!root||root.dataset.heroReady==='1')return;
 const slides=[...root.querySelectorAll('[data-hero-slide]')];
 if(slides.length<1)return;
 root.dataset.heroReady='1';
 const dots=[...root.querySelectorAll('[data-hero-dot]')];
 const prev=root.querySelector('[data-hero-prev]');
 const nextBtn=root.querySelector('[data-hero-next]');
 const autoplay=root.dataset.autoplay==='true';
 const interval=Math.max(4000,Number(root.dataset.interval)||6000);
 let index=Math.max(0,slides.findIndex(s=>s.classList.contains('is-active'))),timer=null;
 const go=i=>{
  index=(i+slides.length)%slides.length;
  slides.forEach((s,n)=>s.classList.toggle('is-active',n===index));
  dots.forEach((d,n)=>{d.classList.toggle('is-active',n===index);d.setAttribute('aria-selected',n===index?'true':'false')});
 };
 const next=()=>go(index+1);
 const stop=()=>{if(timer){clearInterval(timer);timer=null}};
 const start=()=>{stop();if(autoplay&&slides.length>1)timer=setInterval(next,interval)};
 const restart=()=>{start()};
 prev?.addEventListener('click',()=>{go(index-1);restart()});
 nextBtn?.addEventListener('click',()=>{next();restart()});
 dots.forEach((d,n)=>d.addEventListener('click',()=>{go(n);restart()}));
 root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',start);
 root.addEventListener('focusin',stop);root.addEventListener('focusout',start);
 go(index);start();
}
function scan(){document.querySelectorAll('[data-mr-hero-carousel]').forEach(initHero)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan);else scan();
document.addEventListener('shopify:section:load',e=>{const root=e.target?.matches?.('[data-mr-hero-carousel]')?e.target:e.target?.querySelector?.('[data-mr-hero-carousel]');if(root){root.dataset.heroReady='';initHero(root)}});
document.addEventListener('shopify:section:unload',e=>{const root=e.target?.matches?.('[data-mr-hero-carousel]')?e.target:e.target?.querySelector?.('[data-mr-hero-carousel]');if(root)delete root.dataset.heroReady});
})();
